import React from 'react';
import PropTypes from 'prop-types';
import ProfileCoursesMobile from '../courses/ProfileCoursesMobile';

import WebinarBlockMobile from '../blocks/WebinarBlockMobile';
import TimetableBlockMobile from '../blocks/TimetableBlockMobile';

const CoursesTabContentMobile = props => {
  return (
    <div>
      <ProfileCoursesMobile courses={props.courses} />
      <WebinarBlockMobile webinar={props.webinar} />
      <TimetableBlockMobile timetable={props.timetable} />
    </div>
  );
};

CoursesTabContentMobile.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      webinarsCount: PropTypes.number.isRequired,
      webinarsPassed: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  webinar: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
  }).isRequired,
  timetable: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      times: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
};

export default CoursesTabContentMobile;
